import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import Header from './components/Header';
import Hero from './components/Hero';
import PerformanceStats from './components/PerformanceStats';
import Services from './components/Services';
import Footer from './components/Footer';
import { siteConfig } from './config/siteConfig';
import AboutSections from "./components/image/AboutSections";
import VehicleShowcase from "./components/vehicules/VehicleShowcase";
import {vehicleData} from "./components/vehicules/vehicleData";
import ServicesDetailed from "./components/services/ServicesDetailed";
import {servicesDetailedData} from "./components/services/servicesDetailedData";
import BrandShowcase from "./components/brands/BrandShowcase";
import {brandShowcaseData} from "./components/brands/brandShowcaseData";

// Create custom theme based on siteConfig
const theme = createTheme({
    palette: {
        primary: {
            main: siteConfig.colors.primary,
        },
        secondary: {
            main: siteConfig.colors.secondary,
        },
    },
    typography: {
        fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 700,
            letterSpacing: '-0.5px',
        },
        h2: {
            fontWeight: 700,
            letterSpacing: '-0.5px',
        },
        h3: {
            fontWeight: 700,
            letterSpacing: '-0.5px',
        },
        h4: {
            fontWeight: 600,
        },
        h5: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
    },
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div className="App">
                <Header />
                <Hero />
                <PerformanceStats />
                <AboutSections></AboutSections>
                <Services />
                <ServicesDetailed services={servicesDetailedData}></ServicesDetailed>
                <VehicleShowcase vehicles={vehicleData} />
                <BrandShowcase brands={brandShowcaseData}></BrandShowcase>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default App;
